var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ui-card",style:(`width: ${_vm.width}`)},[_c('ui-form',{on:{"submit":_vm.onSubmit}},[_c('div',{staticClass:"p-4"},[_vm._t("default")],2),(_vm.hasActions)?_c('div',{staticClass:"ui-card-actions px-4 py-4"},[_vm._t("actions")],2):_vm._e()])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }